import { Box, Stack } from '@mui/material';

export function TextButton({
  onClick,
  text,
  icon,
}: {
  onClick: () => void;
  text: string;
  icon: React.ReactNode;
}) {
  return (
    <Stack
      onClick={onClick}
      direction={'row'}
      alignItems={'center'}
      spacing={0.5}
      fontWeight={700}
      fontSize={14}
      style={{ cursor: 'pointer' }}
    >
      {icon}
      <Box fontWeight={600}>{text}</Box>
    </Stack>
  );
}
